export const UDO = Object.freeze({
  NotSet: '(not set)',
});

export enum CategoryL1 {
  profile = 'FAVORITE',
  myAccount = 'My Account',
}

export enum CategoryL2 {
  profile = 'FAVORITE',
  myFavorites = 'My Favorites',
  SubNavMenu = "sub_nav"
}
export enum CategoryL3 {
  profile = 'FAVORITE',
  MyGarage = "My Garage"
}

export enum Event_Name {
  UnsaveVehicle = 'unsave_vehicle',
  ShopInventory = 'shop_inventory',
  ShopMoreInventory = 'shop_more_inventory',
  ShopNow = 'shop_now',
  VehicleClick = 'vehicle_click',
  UndoRemovedFromFavorites = 'undo_removed_from _favorites',
  SubNavMenu = 'sub_nav'
}

export enum Event_Category {
  UserActivityType = 'UserActivityType',
  engagementType = 'EngagementType'
}

export enum Event_Action {
  UserActivityType_MyAccount_Click = 'UserActivityType_my_account|||Click',
  subNavType = 'EngagementType_sub_nav|||Click'
}

export enum Event_Label {
  UnsaveVehicle = 'Unsave Vehicle',
  ShopInventory = 'Shop Inventory',
  ShopMoreInventory = 'Shop More Inventory',
  ShopNow = 'Shop Now',
  UndoRemovedFromFavorites = 'Undo Removed From Favorites',
  MyGarage = 'My Garage',
  Favorites = 'Favorites',
  Notifications = 'Notifications',
  Settings = 'Settings',
  ServiceHistory = 'Service Visits'
}

export enum Event_PageGroup {
  My_Account = 'my account',
}

export const API_URLS = {
  LOCAL: 'http://localhost:4000',
  Get_VehicleInfo_API_URL:
    '/my-account/my-favorite/api/MyGarage/getFavoriteVehiclesDetailWithDeals',
  Remove_Fav_API_URL: '/my-account/my-favorite/api/MyGarage/removeFavorite',
  Save_Fav_API_URL: '/my-account/my-favorite/api/MyGarage/saveFavoriteVehicle',
};
